export default "__VITE_ASSET__B3IOJx4E__"